import {useApiMutation} from "@/lib/hook";
import {Card, Form, Input} from "antd";
import {myLinks} from "@/lib/routes/myLinks";
import {useRouter} from "next/navigation";
import {FormButton, MyForm} from "@/theme";
import {PermissionsSelect} from "@/components";
const {TextArea} = Input;

export const CreateRole = ({initData, isCreate, canUpdate = true}) => {
    const [form] = Form.useForm();
    const route = useRouter();
    const update = useApiMutation({
        onSuccess: (client, resp, variables) => {
            switch (variables.route.name) {
                case 'authorization.roles.store':
                    route.replace(myLinks.getUlr('roles', {slug: resp.data.role.name}))
                    break;
                case 'authorization.roles.update':
                    formSubmitEvent(form)
                    break;
            }
        }
    })

    const onFinish = (values) => {
        update.mutate({
            route: isCreate ? { name: 'authorization.roles.store' } : { name: 'authorization.roles.update', query: { id: initData.id } },
            data: isCreate ? {
                ...values
            } : {
                ...values,
                name: initData.name
            }
        })
    };

    return (
        <>
            <MyForm
                spinning={update.isLoading}
                form={form}
                name="role"
                initialValues={initData}
                autoComplete="off"
                layout={'vertical'}
                onFinish={onFinish}
            >
                <Card
                    title={isCreate ? 'Adding a role' : 'Edit role'}
                >
                    {isCreate &&
                        <Form.Item
                            label='Role key'
                            name='name'
                            wrapperCol={{
                                span: 12,
                            }}
                        >
                            <Input />
                        </Form.Item>
                    }
                    <Form.Item
                        label='Role title'
                        name='title'
                        wrapperCol={{
                            span: 12,
                        }}
                    >
                        <Input
                            disabled={!canUpdate}
                        />
                    </Form.Item>
                    <Form.Item
                        label='Role Description'
                        name='description'
                    >
                        <TextArea
                            style={{ resize: 'none' }}
                            rows={4}
                            disabled={!canUpdate}
                        />
                    </Form.Item>

                    <Form.Item
                        label='Role permissions'
                        name='permissions'
                    >
                        <PermissionsSelect
                            allowClear
                            disabled={!canUpdate}
                        />
                    </Form.Item>
                </Card>

                {(canUpdate) &&(
                    <FormButton
                        isCreate={isCreate}
                        useBack
                    />
                )}

            </MyForm>
        </>
    )
}